// Shared input state bridging the touch D-pad / A / B buttons drawn by
// UIScene with the keyboard handling in LibraryScene. Both scenes run
// concurrently (LibraryScene launches UIScene on top of it), so a small
// module-level singleton is simpler and more robust here than wiring up a
// custom event bus for four booleans and two buttons.

import type { Direction } from '../logic/movement';

class VirtualInputState {
  private readonly directions: Record<Direction, boolean> = {
    up: false,
    down: false,
    left: false,
    right: false,
  };

  private aPressed = false;
  private bPressed = false;

  setDirection(direction: Direction, active: boolean): void {
    this.directions[direction] = active;
  }

  isDirectionActive(direction: Direction): boolean {
    return this.directions[direction];
  }

  /** Call from the UIScene A-button pointerdown handler. */
  pressA(): void {
    this.aPressed = true;
  }

  /** Call from the UIScene B-button pointerdown handler. */
  pressB(): void {
    this.bPressed = true;
  }

  /** Edge-triggered read: returns true at most once per press. */
  consumeA(): boolean {
    if (this.aPressed) {
      this.aPressed = false;
      return true;
    }
    return false;
  }

  /** Edge-triggered read: returns true at most once per press. */
  consumeB(): boolean {
    if (this.bPressed) {
      this.bPressed = false;
      return true;
    }
    return false;
  }
}

export const virtualInput = new VirtualInputState();
